import { HttpClient } from '@injectivelabs/utils'
import { app } from './App'
import { MINTSCAN_BASE_URL } from '~/app/utils/constants'
import { BasicData, NetworkStatus } from '~/types'

export class HttpConsumer {
  private httpClient: HttpClient

  constructor(baseUrl: string) {
    this.httpClient = new HttpClient(baseUrl)
  }

  async getNetworkStatus(): Promise<{ data: NetworkStatus }> {
    try {
      return await this.httpClient.get(
        `${app.appUrlEndpoint.explorerUrl}/status`
      )
    } catch (e) {
      return await this.httpClient.get(`${MINTSCAN_BASE_URL}/status`) // TODO
    }
  }

  async getTokenBasicData(id: string): Promise<{ data: BasicData }> {
    try {
      return await this.httpClient.get(
        `${app.appUrlEndpoint.explorerUrl}/market?id=${id}`
      )
    } catch (e) {
      return await this.httpClient.get(`${MINTSCAN_BASE_URL}/market?id=${id}`) // TODO
    }
  }

  getMarketChartRange(
    id = 'injective-protocol',
    from: number,
    to: number
  ): Promise<{
    // eslint-disable-next-line camelcase
    data: { prices: [[number, number]]; total_volumes: [[number, number]] }
  }> {
    const endpoint = 'https://api.coingecko.com/api/v3'
    const getMarketRange = (
      id = 'injective-protocol',
      from: number,
      to: number
    ) => `/coins/${id}/market_chart/range?vs_currency=usd&from=${from}&to=${to}`

    return this.httpClient.get(`${endpoint}${getMarketRange(id, from, to)}`)
  }
}

export const httpConsumer = new HttpConsumer(app.appUrlEndpoint.baseUrl)
